import React from "react";

export function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="mb-8 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
      <div>
        {eyebrow && <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500 mb-2">{eyebrow}</div>}
        <h1 className="font-serif-display text-4xl sm:text-5xl leading-none tracking-tight">{title}</h1>
        {description && <p className="mt-3 text-sm text-zinc-600 max-w-2xl">{description}</p>}
      </div>
      {actions && <div className="flex gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}

export function Stat({ label, value, hint, testid }) {
  return (
    <div data-testid={testid} className="border border-zinc-200 bg-white p-5 rounded-md">
      <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500">{label}</div>
      <div className="mt-2 font-serif-display text-3xl">{value}</div>
      {hint && <div className="text-xs text-zinc-500 mt-1">{hint}</div>}
    </div>
  );
}
